module.exports = __webpack_public_path__ + "static/img/scene09.3823b5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene09.png
// module id = 2uHW
// module chunks = 1